import "./FreelanceRevenueManagerForHire.module.css";
import Header from "@/reusable_sections/Header";
import RevenueHero from "./sections/RevenueHero";
import Modelcomparison from "./sections/Modelcomparison";
import Pricing from "./sections/Pricing";
import Revenuecasestudies from "./sections/Revenuecasestudies";
import Hiringprocessfaq from "./sections/Hiringprocessfaq";
import Services from "./sections/Services";
import Footer from "@/reusable_sections/Footer";
export default function FreelanceRevenueManagerForHirePage() {
  return <div>
      <Header />
      <RevenueHero />
      <Modelcomparison />
      <Pricing />
      <Revenuecasestudies />
      <Hiringprocessfaq />
      <Services />
      <Footer />
    </div>;
}